import React, { useState } from 'react';
import api, { errorMessage } from '../api';
import { useAuth } from '../context/AuthContext';
import LocationAccess from './LocationAccess';

export default function Settings({ onLocationGranted }) {
  const { user, setUser, logout } = useAuth();
  const [shareLocation, setShareLocation] = useState(Boolean(user.share_location));
  const [shareDestination, setShareDestination] = useState(Boolean(user.share_destination));
  const [status, setStatus] = useState(null); // { type, text }
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setStatus(null);
    setBusy(true);
    try {
      const res = await api.put('/user/settings', {
        share_location: shareLocation,
        share_destination: shareDestination,
      });
      setUser(res.data);
      setStatus({ type: 'success', text: 'Sparat!' });
      setTimeout(() => setStatus(null), 2000);
    } catch (err) {
      setStatus({ type: 'error', text: errorMessage(err, 'Kunde inte spara inställningarna.') });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <h3>Inställningar</h3>

      {/* Atkomsten forst: utan den har reglagen nedan ingen verkan. */}
      <LocationAccess onGranted={onLocationGranted} />

      <p className="section-label">Vem ser din plats</p>

      <div className="settings-toggle">
        <div>
          <label htmlFor="share-location">Dela min plats med vänner</label>
          <p className="settings-toggle__help">
            Bara dina accepterade vänner ser var du är, och bara medan appen är öppen.
          </p>
        </div>
        <input
          id="share-location"
          type="checkbox"
          checked={shareLocation}
          onChange={e => setShareLocation(e.target.checked)}
        />
      </div>

      <div className="settings-toggle">
        <div>
          <label htmlFor="share-destination">Dela min destination med vänner</label>
          <p className="settings-toggle__help">
            Visar vart du är på väg för dina vänner när du har en rutt igång.
          </p>
        </div>
        <input
          id="share-destination"
          type="checkbox"
          checked={shareDestination}
          onChange={e => setShareDestination(e.target.checked)}
        />
      </div>

      <button className="btn btn--primary btn--block" onClick={save} disabled={busy}>
        {busy ? 'Sparar...' : 'Spara'}
      </button>

      {status && (
        <p className={`notice notice--${status.type}`}>{status.text}</p>
      )}

      <button className="btn btn--quiet btn--block" onClick={logout} style={{ marginTop: 'var(--space-xl)' }}>
        Logga ut
      </button>

    </div>
  );
}
